import { makeStyles } from "@mui/styles";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format } from "date-fns";
import { useMemo, useState } from "react";
import { AppColors } from "resources/AppColors";
import { datePickerDateRangeErrorTexts } from "../DatePickerNew/constants";

const useStyles = makeStyles((theme) => ({
  textFieldLabel: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: AppColors.PRIMARY,
      },
    },
    "& .MuiInputBase-root": {
      color: AppColors.PRIMARY,
    },
    "& .MuiInputLabel-root": {
      color: AppColors.PRIMARY,
    },
    color: AppColors.PRIMARY,
    backgroundColor: AppColors.BOX_FILL,
  },
}));

function DatePickerMonitoring({
  value,
  setValue,
  isExport,
  label,
  minDate,
  maxDate,
  required,
  reference,
  textfieldProps,
  ...other
}) {
  const [error, setError] = useState(null);
  const classes = useStyles();

  const errorMessage = useMemo(() => {
    let minDateHumanReadable = ""
    let maxDateHumanReadable = ""

    if (minDate && !isNaN(minDate)) {
      const formattedMinDate = format(minDate, 'dd/MM/yyyy')
      minDateHumanReadable = formattedMinDate?.toString()
    } else {
      minDateHumanReadable = "01/01/1900"
    }
    if (maxDate && !isNaN(maxDate)) {
      const formattedMaxDate = format(maxDate, 'dd/MM/yyyy');
    maxDateHumanReadable = formattedMaxDate.toString();
    } else {
      maxDateHumanReadable = "31/12/2099"
    }

    const errorTexts = datePickerDateRangeErrorTexts({ minDate: minDateHumanReadable, maxDate: maxDateHumanReadable })

    switch (error) {
      case 'minDate': {
        return errorTexts.MinDateError
      }
      case 'maxDate': {
        return errorTexts.MaxDateError
      }

      case 'invalidDate': {
        return errorTexts.INVALID_DATE;
      }

      default: {
        return '';
      }
    }
  }, [error, minDate, maxDate]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        ref={reference}
        value={value}
        onChange={setValue}
        label={label}
        minDate={minDate}
        maxDate={maxDate}
        format={isExport ? "MM/yyyy" : "dd/MM/yyyy"}
        onError={(newError) => setError(newError)}
        slotProps={{
          textField: {
            required,
            className: classes.textFieldLabel,
            ...textfieldProps,
            InputLabelProps: {
              required: required
            },
            inputProps: {
              placeholder: isExport ? "mm/yyyy" : "dd/mm/aaaa",
            },
          },
        }}
        {...other}
      />
    </LocalizationProvider>
  );
}

export default DatePickerMonitoring;
